.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--tuna-spacing-2);
}

.chips {
  flex: 1 1 auto;
}

/* GH #2519 A: the text filter, at the start of the bar */
.field {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 16rem;
  min-width: 10rem;
}

.input {
  width: 100%;
  min-height: 32px;
  padding: 0 var(--tuna-spacing-4) 0 var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-default, transparent);
  color: inherit;
  font: inherit;
  font-size: var(--tuna-typography-body2-fontSize);
}

.input:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 1px;
}

/* Our own clear button replaces the browser's, so there is one, named and reachable */
.input::-webkit-search-cancel-button {
  appearance: none;
}

.clearText {
  position: absolute;
  right: var(--tuna-spacing-0_5);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--tuna-content-muted);
  cursor: pointer;
}

.clearText:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  border-radius: var(--tuna-shape-borderRadius);
}

/* A real label, hidden on desktop: a placeholder alone is not a label */
.label,
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* Read-only grids: the field alone */
.fieldOnly {
  justify-content: flex-start;
}

.empty {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  padding: var(--tuna-spacing-2) 0;
  font-family: var(--tuna-typography-fontFamily);
  color: var(--tuna-palette-text-secondary);
}

.summary {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-palette-text-secondary);
}

.clear {
  padding: 0;
  border: 0;
  background: none;
  color: var(--tuna-palette-primary-main);
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.clear:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
  border-radius: var(--tuna-shape-radius-sm);
}

/* Phones: sort first, then the chips scrolling sideways in the remaining space */
@media (max-width: 599.95px) {
  .toolbar {
    flex-direction: row-reverse;
    flex-wrap: wrap;
    align-items: center;
  }

  .chips {
    min-width: 0;
  }

  /* GH #2519 A: the field takes its own full-width row above the chips, 44 px tall */
  .field {
    order: -1;
    flex: 1 0 100%;
  }

  .input {
    min-height: 44px;
  }
}

/* iOS zooms into a field under 16 px; coarse pointers get at least that */
@media (pointer: coarse) {
  .input {
    font-size: max(1rem, var(--tuna-typography-body2-fontSize));
  }
}
